import { render, staticRenderFns } from "./activity-table.vue?vue&type=template&id=39855aad&scoped=true&"
import script from "./activity-table.ts?vue&type=script&lang=ts&"
export * from "./activity-table.ts?vue&type=script&lang=ts&"
import style0 from "./activity-table.scss?vue&type=style&index=0&id=39855aad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39855aad",
  null
  
)

export default component.exports